import React, { useState } from 'react';
import { useAuthStore } from "../../stores/useAuthStore";
import { Icon, Button, Message, Modal, Form } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

function TopMenuBar({ menuOpen, setMenuOpen }) {
    const navigate = useNavigate();
    const isAdmin = useAuthStore(state => state.isAdmin);
    const ucdId = useAuthStore(state => state.ucdId);
    const userType = useAuthStore(state => state.userType);
    const churchName = useAuthStore(state => state.churchName);
    const logoutUser = useAuthStore(state => state.logoutUser);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        emailAddress: '',
        description: '',
        churchCode: '',
        userType: userType,
        authCode: 'g4bzFr3EbQjsf6EFTLn2Wjhc'  // Set default authCode
    });

    const handleLogout = () => {
        logoutUser();
        navigate("/");
    };

    const handleHome = () => {
        navigate("/dashboard");
    };

    const handleChange = (e, { name, value }) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        if (!formData.name || !formData.emailAddress || !formData.description) {
            setError('Please fill in all fields');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            await axios.post('https://schedule.ucdir.com/ajax/send-support-email.php', {
                ...formData
            });
            setIsModalOpen(false);
            setFormData({ name: '', emailAddress: '', description: '', churchCode: '', userType: userType, authCode: 'g4bzFr3EbQjsf6EFTLn2Wjhc' });
        } catch (err) {
            setError(err.response?.data?.message || 'An error occurred while submitting the issue');
        } finally {
            alert('Issue was successfully emailed.')
            setLoading(false);
        }
    };

    return (
        <>
            {/*{ucdId.length > 0 && (*/}
            {/*    <div className="scheduling-issues-banner" style={{"border":"1px solid red"}}>*/}
            {/*        <Message*/}
            {/*            error*/}
            {/*            className="clickable-banner"*/}
            {/*            onClick={() => {*/}
            {/*                setFormData(prev => ({ ...prev, churchCode: ucdId }));  // Set churchCode when opening*/}
            {/*                setIsModalOpen(true);*/}
            {/*            }}                    >*/}
            {/*            <h3>If you are experiencing TECHNICAL DIFFICULTIES scheduling an appointment CLICK HERE</h3>*/}

            {/*        </Message>*/}
            {/*    </div>*/}
            {/*)}*/}
            <div className="top-menu-bar-parent">
                <div className="top-menu-bar">
                    <div className="top-menu-bar-left">
                        <img
                            className="top-menu-bar-logo"
                            src="https://ucdir.com/wp-content/uploads/2024/02/UCD_Logo350px.png"
                            alt="UCD Logo"
                        />
                    </div>
                    {ucdId.length > 0 && (
                        <div className="top-menu-bar-right">
                            <div className="info-section">
                                <p className="church-name">{churchName}</p>
                                <p className="church-code">
                                    <strong>Church Code:</strong> {ucdId}
                                </p>
                                {isAdmin && <p className="admin-status"><strong>Master User</strong></p>}
                            </div>
                            <div className="button-section">
                                <Button icon labelPosition="left" onClick={handleHome}>
                                    <Icon name="home" />
                                    Home
                                </Button>
                                <Button icon labelPosition="left" onClick={handleLogout}>
                                    <Icon name="sign-out" />
                                    Logout
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal
                open={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    setError(null);
                    setFormData({ name: '', emailAddress: '', description: '', churchCode: '', userType:userType, authCode: 'g4bzFr3EbQjsf6EFTLn2Wjhc' });
                }}
                size="tiny"
            >
                <Modal.Header>Report Technical Problem</Modal.Header>
                <Modal.Content>
                    <Form error={!!error} loading={loading}>
                        {error && <Message error content={error} />}

                        <Form.Input
                            label="Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />

                        <Form.Input
                            label="Email"
                            name="emailAddress"
                            type="email"
                            value={formData.emailAddress}
                            onChange={handleChange}
                        />

                        <Form.Input
                            label="Church Code"
                            name="churchCode"
                            value={formData.churchCode}
                            disabled
                        />

                        <Form.TextArea
                            label="Description of Problem"
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            required
                            rows={4}
                        />

                        <Form.Input
                            type="hidden"
                            name="authCode"
                            value="g4bzFr3EbQjsf6EFTLn2Wjhc"
                        />

                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setIsModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button primary onClick={handleSubmit} loading={loading}>
                        Submit Issue
                    </Button>
                </Modal.Actions>
            </Modal>

            <style jsx>{`
                .scheduling-issues-banner {
                    width: 100%;
                    background-color: #f8f9fa;
                }

                .clickable-banner {
                    cursor: pointer;
                    margin: 0 !important;
                    text-align: center;
                    width:100%;
                }

                .clickable-banner:hover {
                    background-color: #e9ecef !important;
                }

                /* Existing styles remain the same */
            `}</style>
        </>
    );
}

export default TopMenuBar;